import Cookies from 'js-cookie';
import request from '@qnpm/react-native-ext-fetch-web';
import { UserDataKeyMap } from './map';
import loadJS from '../utils/loadJs';

var noop = function noop() {};

var HAS_LOGIN = 2; // 已登陆

var userInfoCache;
var apis = {
  base: 'https://user.qunar.com/index/basic',
  getLoginState: '//user.qunar.com/webApi/getLoginState.jsp'
};
/**
 * 判断是否已经登录
 * 支持回调和异步两种方式调用
 * @param {function} callBack 回调方法
 */

var checkLogin = function checkLogin(callBack) {
  if (typeof callBack === 'function') {
    // 判断登录状态
    request({
      method: 'GET',
      url: apis.getLoginState
    }).then(function (res) {
      if (res.ret && res.data && res.data.loginState === HAS_LOGIN) {
        callBack(true);
      } else {
        callBack(false, res.data);
      }
    })["catch"](function () {
      callBack(false);
    });
  } else {
    // 判断登录状态
    return new Promise(function (resolve, reject) {
      request({
        method: 'GET',
        url: apis.getLoginState
      }).then(function (res) {
        if (res.ret && res.data && res.data.loginState === HAS_LOGIN) {
          resolve(true);
        } else {
          resolve(false, res.data);
        }
      })["catch"](function (err) {
        reject(err);
      });
    });
  }
};
/**
 * 判断是否已经登录通过cookie
 * @param {function} callBack 回调方法
 */


var checkLoginByCookie = function checkLoginByCookie(callBack) {
  // 判断登录状态
  var q = Cookies.get('_q') || '';
  var t = Cookies.get('_t') || '';

  if (q !== '' && t !== '') {
    callBack(true);
  } else {
    callBack(false);
  }
};
/**
 * 执行登录方法
 * @param {function} callBack 成功回调
 * @param {function} errCallBack 失败回到
 */


var loginFn = function loginFn(callBack, errCallBack) {
  var instance = window.ucAPI && window.ucAPI.loginDialog && window.ucAPI.loginDialog.createInstance({
    instanceConfig: {
      weixinAuth: false
    },
    success: function success() {
      callBack({
        ret: 0,
        meg: '登录成功'
      });
    },
    fail: function fail(err) {
      errCallBack(err);
    }
  });

  if (instance) {
    setTimeout(function () {
      instance.instanceFunc.showDialog();
    }, 100);
  } else {
    console.warn('未找到ucapi');
    errCallBack('未找到ucapi');
  }
};
/**
 * TODO 这里动态加载js脚本有问题，暂时在模板当中直接写script
 * 登录方法外层方法，这里按需加载ucapi
 * @param {function} callBack 成功回调
 * @param {function} errCallBack 失败回调
 */


var login = function login(callBack) {
  var errCallBack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

  // 参数断言
  if (typeof callBack !== 'function') {
    console.error('callBack参数需要是一个方法');
    return;
  } // TODO 这里动态加载js脚本有问题，暂时在模板当中直接写script


  if (!window.ucAPI) {
    loadJS("https://common.qunarzz.com/buri/prd/scripts/api/index.js?_t=".concat(new Date().getTime()), function () {
      loginFn(callBack, errCallBack);
    });
  } else {
    loginFn(callBack, errCallBack);
  }
};
/**
 * 获取用户信息
 * @param {function} callBack 成功回调
 * @param {function} errCallBack 失败回调
 */


var getLoginInfo = function getLoginInfo(callBack) {
  var errCallBack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

  // 参数断言
  if (typeof callBack !== 'function') {
    console.error('callBack参数需要是一个方法');
    return;
  } // 判断登录状态


  checkLoginByCookie(function (isLogin, err) {
    if (!isLogin) {
      userInfoCache = undefined;
      errCallBack(err);
      return;
    }

    if (userInfoCache) {
      callBack(userInfoCache);
    } else {
      userInfoCache = undefined;
      request({
        method: 'GET',
        url: apis.base + "?_n=".concat(Math.random()),
        param: {
          csrfToken: Cookies.get('csrfToken')
        }
      }).then(function (resData) {
        var retData = {};
        var originData = resData.data;

        for (var i = 0; i < UserDataKeyMap.length; i++) {
          retData[UserDataKeyMap[i].toKey] = originData[UserDataKeyMap[i].fromKey];
        }

        userInfoCache = retData;
        callBack(retData);
      })["catch"](function (error) {
        errCallBack(error);
      });
    }
  });
};

var loginWithParam = function loginWithParam(param, callBack) {
  var errCallBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;

  if (process.env.NODE_ENV !== 'production' && !param) {
    console.warn('参数目前不做任何处理');
  }

  login(callBack, errCallBack);
};

export default {
  login: login,
  checkLogin: checkLogin,
  getLoginInfo: getLoginInfo,
  loginWithParam: loginWithParam
};